import { Paper, Stack, Text, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/fund/$id/dex')({
  component: DexPage,
})

function DexPage() {
  const { id } = Route.useParams()

  return (
    <Stack align="stretch" justify="flex-start" gap="md">
      <Paper shadow="sm" p="lg" radius="md" withBorder>
        <Title order={2}>Decentralized Exchange</Title>
        <Text>DEX interface will be available here. Fund ID {id}</Text>
      </Paper>
    </Stack>
  )
}
